const CommonHandlerPlugin = {
  install(Vue) {
    const dlInvoicePDF = async (
      invoice_no,
      shipment_dt,
      tehaisaki_kbn,
      tehaisaki_na
    ) => {
      const response = await Vue.prototype.postAsteria(
        "CommonAPI",
        "dlInvoicePDF",
        {
          invoice_no,
          shipment_dt,
          tehaisaki_kbn,
          tehaisaki_na
        }
      );

      if (response.responseData.return != 0) {
        return;
      }

      Vue.prototype.$downloadFile(
        response.responseData.file_na,
        response.responseData.pdfFile,
        "application/pdf"
      );
    };

    const getAddress = async (post_cd, delivery_registration_request_kbn) => {
      if (!post_cd) {
        return false;
      }
      if (!delivery_registration_request_kbn) {
        delivery_registration_request_kbn = 0;
      }

      const response = await Vue.prototype.postAsteria(
        "CommonAPI",
        "getAddress",
        {
          post_cd,
          delivery_registration_request_kbn
        },
        true
      );

      if (response.responseData.return != 0) {
        return false;
      }

      return response.responseData.address;
    };

    const getSplitAddress = async (
      post_cd,
      delivery_registration_request_kbn
    ) => {
      if (!post_cd) {
        return false;
      }

      if (!delivery_registration_request_kbn) {
        delivery_registration_request_kbn = 0;
      }
      const response = await Vue.prototype.postAsteria(
        "CommonAPI",
        "getAddress",
        {
          post_cd,
          delivery_registration_request_kbn
        },
        true
      );

      if (response.responseData.return != 0) {
        return false;
      }

      return response.responseData;
    };

    Vue.prototype.$commonHandler = {
      dlInvoicePDF,
      getAddress,
      getSplitAddress
    };
  }
};

export default CommonHandlerPlugin;
